import React, { useMemo, useState } from "react";
import {
    Box,
    Typography,
    IconButton,
    useTheme,
} from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { tokens } from "../../theme";
export type FrontendStatus =
    | "enquiry"
    | "confirmed"
    | "fulfilled"
    | "cancelled"
    | "lost"
    | "testing";

interface Booking {
    id: number;
    title: string;
    service: string;
    package: string;
    paymentStatus: string;
    deceased?: {
        id: number;
        first_name: string;
        surname: string;
        date_of_birth: string;
        date_of_death: string;
        gender: string;
        person_image: string;
    }[];

    dateOfService: string;
    status: FrontendStatus;
    bookingType: string;
    startTime: string;
    endTime?: string;
}

interface WeeklyCalendarProps {
    bookings: Booking[];
}

const hours = Array.from({ length: 24 }, (_, i) => i);

const getStartOfWeek = (date: Date) => {
    const d = new Date(date);
    const day = d.getDay();
    const diff = day === 0 ? -6 : 1 - day;
    d.setDate(d.getDate() + diff);
    return d;
};

const WeeklyCalendar: React.FC<WeeklyCalendarProps> = ({ bookings }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [currentDate, setCurrentDate] = useState(new Date());
const navigate = useNavigate()
    const startOfWeek = useMemo(() => getStartOfWeek(currentDate), [currentDate]);
    console.table(bookings)
    const days = useMemo(() => {
        return Array.from({ length: 7 }).map((_, i) => {
            const d = new Date(startOfWeek);
            d.setDate(startOfWeek.getDate() + i);
            return d;
        });
    }, [startOfWeek]);

    const handlePrevWeek = () => {
        const prev = new Date(currentDate);
        prev.setDate(prev.getDate() - 7);
        setCurrentDate(prev);
    };

    const handleNextWeek = () => {
        const next = new Date(currentDate);
        next.setDate(next.getDate() + 7);
        setCurrentDate(next);
    };

   const getBookingsForSlot = (day: Date, hour: number) => {
  return bookings.filter((booking) => {
    const [dayNum, month, year] = booking.dateOfService.split("-").map(Number);
    const date = new Date(year, month - 1, dayNum);

    const startHour = parseInt(booking.startTime.split(":")[0]);
// console.log(`Date : ${date.toDateString()} \nHour: ${startHour} \nDay : ${day}`)
    return (
      date.toDateString() === day.toDateString() &&
      startHour === hour
    );
  });
};

    return (
        <Box sx={{backgroundColor:colors.primary[900], borderRadius:4, p:3}}>

            {/* Header */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <IconButton onClick={handlePrevWeek}>
                    <ArrowBackIos fontSize="small" />
                </IconButton>

                <Typography fontWeight="bold">
                    Week of {startOfWeek.toDateString()}
                </Typography>

                <IconButton onClick={handleNextWeek}>
                    <ArrowForwardIos fontSize="small" />
                </IconButton>
            </Box>

            {/* Calendar Grid */}
            <Box display="grid" gridTemplateColumns="80px repeat(7, 1fr)">

                {/* Day Headers */}
                <Box />
                {days.map((day, i) => (
                    <Box
                        key={i}
                        textAlign="center"
                        borderBottom={`1px solid ${colors.primary[300]}`}
                        p={1}
                    >
                        <Typography fontWeight="bold">
                            {day.toLocaleDateString("default", { weekday: "short" })}
                        </Typography>

                        <Typography variant="caption">
                            {day.getDate()}
                        </Typography>
                    </Box>
                ))}

                {/* Time Rows */}
                {hours.map((hour) => (
                    <React.Fragment key={hour}>

                        {/* Time Label */}
                        <Box
                            borderRight={`1px solid ${colors.primary[300]}`}
                            p={1}
                            fontSize="12px"
                        >
                            {hour}:00
                        </Box>

                        {days.map((day, i) => {
                            //error  here
                            const slotBookings = getBookingsForSlot(day, hour);
                            // console.log(day)
                            // console.table(slotBookings)
                            return (
                                <Box
                                    key={i}
                                    border={`1px solid ${colors.primary[300]}`}
                                    minHeight={60}
                                    p={0.5}
                                >
                                    {slotBookings.map((booking) => (
                                        <Box
                                            key={booking.id}
                                            onClick={()=>navigate(`/bookings/${booking.id}`)}
                                            sx={{
                                                background: theme.palette.primary.light,
                                                color: "#fff",
                                                p: 0.5,
                                                borderRadius: "4px",
                                                fontSize: "11px",
                                                mb: 0.5
                                            }}
                                        >
                                            {booking.title}
                                        </Box>
                                    ))}
                                </Box>
                            );
                        })}
                    </React.Fragment>
                ))}
            </Box>
        </Box>
    );
};

export default WeeklyCalendar;